import EmbedIframe from './EmbedIframe';

export default EmbedIframe;
